const modules = {};

/* System */
const systemValidationFiles = require.context(
    "System", // current directory
    true, // subdirectories
    /validate\.[a-zA-Z0-9_]+\.json$/ // only .json
);

systemValidationFiles.keys().forEach((filename) => {
    // create the module name from fileName
    // remove the store.js extension and capitalize
    const moduleName = filename
        .substring(filename.lastIndexOf("/") + 1)
        .replace(/validate\./g, "")
        .replace(/.json/g, "");

    modules["rules_" + moduleName] = systemValidationFiles(filename).default || systemValidationFiles(filename);
});

/* Application */
const moduleValidationFiles = require.context(
    "Application", // current directory
    true, // subdirectories
    /validate\.[a-zA-Z0-9_]+\.json$/ // only .json
);

moduleValidationFiles.keys().forEach((filename) => {
    // create the module name from fileName
    // remove the store.js extension and capitalize
    const moduleName = filename
        .substring(filename.lastIndexOf("/") + 1)
        .replace(/validate\./g, "")
        .replace(/.json/g, "");

    modules["rules_" + moduleName] = moduleValidationFiles(filename).default || moduleValidationFiles(filename);
});

//console.log(modules);
export default modules;
